import { Injectable } from '@angular/core';
import { RxStomp } from '@stomp/rx-stomp';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RxStompService extends RxStomp {
  private readonly MAX_FAILURES = 3;
  private failureCount = 0;
  private failed = false;

  public readonly connectionLost$ = new BehaviorSubject<boolean>(false);

  constructor() {
    super();
    this.monitorWebSocketConnection();
  }

  monitorWebSocketConnection() {
    this.connected$.subscribe(() => {
      this.failureCount = 0;
      this.failed = false;
      this.connectionLost$.next(false);
    });

    this.stompErrors$.subscribe({
      next: () => {
        this.registerFailure();
      }
    });

    this.webSocketErrors$.subscribe({
      next: () => {
        this.registerFailure();
      }
    });
  }

  registerFailure() {
    this.failureCount++;

    if (this.failureCount >= this.MAX_FAILURES && this.failed === false) {
      this.connectionLost$.next(true);
      this.failed = true;
    }
  }
}